import React, { useState, useEffect } from 'react';

import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import CurrentBalance from 'components/CurrentBalance/CurrentBalance';
import MonthlyRate from 'components/MonthlyRate/MonthlyRate';
import IntroSection from './components/IntroSection/IntroSection';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import Editdisposibleincome from './components/Editdisposibleincome/Editdisposibleincome';
import PageLink from 'components/PageLink/PageLink';
import styles from './UpdatePaymentPlanChangeAmountPageData.module.scss';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import http from 'app/http';
import EditMonthlyIncomeandExpenditure from 'components/EditMonthlyIncomeandExpenditure/EditMonthlyIncomeandExpenditure';
import classnames from 'classnames/bind';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}
const UpdatePaymentPlanChangeAmountPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const dispatch = useAppDispatch();
  const [showEditDisposablePopup, setShowEditDisposablePopup] = useState(false);
  let history = useHistory();
  const [instalmentValue, setinstalmentValue] = useState(
    Model.SelectedInstalmentValue / 100,
  );
  const [InstallmentAmountUnchanged, setInstallmentAmountUnchanged] = useState(
    Model?.SelectedInstallmentAmountUnchanged,
  );
  const [numberofMonth, setnumberofMonth] = useState(
    Model?.PlanDetails.PlanDetailsNumberofInstallments,
  );
  const [finalPaymentValue, setFinalPaymentValue] = useState(
    Model?.FinalToBePaid,
  );
  const [availableIncome, setAvailableIncome] = useState<string>(Model?.DisposableFormModel?.DisposableIncome);
  const [isDisabled, setisDisabled] = useState(false);
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const updateAmountslider = (value: any) => {
    setinstalmentValue(value);
  };
  const UpdateNumberofMonth = (value: any) => {
    setnumberofMonth(value);
  };
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  const formsubmit = async (e: any) => {
    e.preventDefault();
    if (
      Model?.FormModel.PayerReviewType === null &&
      Model.SelectedInstalmentValue === instalmentValue * 100
    ) {
      console.log('yyy');
      setInstallmentAmountUnchanged(true);
    } else {
      try {
        const response = await http.post(
          Model?.NextUrl,
          // Convert object into string
          qs.stringify({
            'FormModel.SelectedAmount': instalmentValue,
            'FormModel.PayerReviewType': Model?.FormModel.PayerReviewType,
          }),
          {
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
            },
          },
        );
        if (response && response.data) {
          // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
          let nextPagePath = '';
          if (!response.data.RedirectUrl) {
            nextPagePath = getPathnameFromUrl(Model?.NextUrl);

            //dispatch(setContent({ [nextPagePath]: response.data }));
          } else {
            nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
          }

          // Add response to store
          //dispatch(setContent({ [nextPagePath]: response.data.RedirectUrl }));
          // Redirect to next step path
          history.push(nextPagePath, {
            noRefresh: true,
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
  };
  const getFinalPaymentOnAmountChange = async () => {
    const pathurlToGetFinalPayment = getPathnameFromUrl(
      Model.PostAmountToGetFinalPaymentUrl,
    );
    try {
      const response = await http.post(
        pathurlToGetFinalPayment,
        // Convert object into string
        qs.stringify({
          selectedAmount: instalmentValue,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data && response.data.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        setFinalPaymentValue(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length > 0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Payment Plan Update',
          checkout_step_number: '2',
          is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);
  return (
    <>
      <form onSubmit={formsubmit}>
        <div className={styles.wrapper}>
          <div className={styles.section}>
            <div className={styles.container}>
              <ChangePlanHeader Headingtext={PageData?.Heading} />
              <div className="CreateRepaymentPlan">
                <div className="CreateRepaymentPlan__section u-hidden">
                  <IntroSection Description={PageData?.Description} />
                </div>
                <div className="CreateRepaymentPlan__section">
                  <CurrentBalance
                    heading={PageData?.CurrentBalanceLabel}
                    currency={Model?.Currency}
                    balance={Model?.CurrentBalanceAmount}
                    balanceTooltip={PageData?.CurrentBalanceTooltip}
                    noPaymentPlan={
                      Model?.PageData?.CurrentBalanceTooltip ||
                      Model?.IsCmsEditMode
                    }
                    noPaymentPlanHeading={PageData?.CurrentBalanceTooltip}
                    noPaymentPlanTooltip={PageData?.CurrentBalanceTooltip}
                  />
                </div>
                <div className="CreateRepaymentPlan__calculation calculation u-marginBz">
                  <MonthlyRate
                    UpdateNumberofMonth={UpdateNumberofMonth}
                    updateAmountslider={updateAmountslider}
                    InstallmentAmountchanged={InstallmentAmountUnchanged}
                    setisDisabled={setisDisabled}
                    setFinalPaymentValue={setFinalPaymentValue}
                    availableIncome={availableIncome}
                    {...props}
                  />
                </div>
              </div>
              {Model.SliderShowMonths == true && (
                <RepaymentList
                  Heading={PageData?.PlanSummaryHeadingLabel}
                  Monthlylabel={PageData?.PlanSummaryNewPaymentLabel}
                  Mothlyamount={instalmentValue}
                  Currencysymbol={Model?.FormattedCurrencySymbol}
                  IsCurrencyOnTheLeftSide={LayoutModel?.IsCurrencyOnTheLeftSide}
                  Decimalseparator={
                    LayoutModel?.DecimalSeparatorForNumberFormatter
                  }
                  Finallabel={PageData?.FinalPaymentLabel}
                  FinalAmount={
                    finalPaymentValue > 0 ? finalPaymentValue / 100 : 0
                  }
                  Totaltext={PageData?.PlanSummaryTotalAmountLabel}
                  Totalamount={Model?.CurrentBalanceAmount}
                  DisposableIncomeLimit={Model?.DisposableIncomeLimit}
                  NumberofMonth={numberofMonth}
                />
              )}
              <Editdisposibleincome
                instalmentValue={instalmentValue}
                setShowEditDisposablePopup={setShowEditDisposablePopup}
                {...props}
              />
              <div className="Grid">
                <div className="Grid-cell">
                  <div className="CreateRepaymentPlan__ctaWrapper button-alignment">
                    <PageLink
                      url={Model.BackUrl}
                      text={PageData.BackBtnLabel}
                      className="Button Button--gray CreateRepaymentPlan__cancelBtn"
                    />
                    <button
                      type="submit"
                      id="update-plan-amount-submit"
                      className={
                        'Button CreateRepaymentPlan__confirmBtn action continue-button ' +
                        (isDisabled ? styles.disabled : '')
                      }
                    >
                      <span>{PageData.NextBtnLabel}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        className={classnames(
          showEditDisposablePopup ? 'modal-overlay is-active' : 'modal-overlay',
        )}
      >
        <div className="modal-dialog">
          <EditMonthlyIncomeandExpenditure
            closePop={setShowEditDisposablePopup}
            Model={Model}
            PageData={PageData}
            instalmentValue={instalmentValue}
            layoutModel={LayoutModel}
            setAvailableIncome={setAvailableIncome}
            availableIncome={availableIncome}
          />
        </div>
      </div>
    </>
  );
};

export default UpdatePaymentPlanChangeAmountPageData;
